// Devtools openen binnen de Discord-iframe kan, maar is omslachtig. Daarom
// schrijft alles wat er tijdens de handshake gebeurt ook naar een paneel in
// de UI zelf. Kan later weg zodra het spel er staat.

export type LogLevel = 'info' | 'ok' | 'warn' | 'error'

const listeners = new Set<(line: LogLine) => void>()

export interface LogLine {
  at: Date
  level: LogLevel
  message: string
}

export const history: LogLine[] = []

export function log(level: LogLevel, message: string, detail?: unknown): void {
  const line: LogLine = { at: new Date(), level, message }
  history.push(line)

  const consoleMethod = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log
  if (detail === undefined) {
    consoleMethod(`[activity] ${message}`)
  } else {
    consoleMethod(`[activity] ${message}`, detail)
  }

  for (const listener of listeners) listener(line)
}

export function onLog(listener: (line: LogLine) => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Haalt een leesbare tekst uit iets dat we ge-catcht hebben. */
export function describeError(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  try {
    return JSON.stringify(error)
  } catch {
    return String(error)
  }
}
